import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

const API_URL = process.env.REACT_APP_API_URL || "";

const initialNew = {
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  paese: "", // nel backend va mappato a "store"
  birth_date: "",
  is_adult_confirmed: false,
  privacy_accepted: false,
  terms_accepted: false,
  alcohol_policy_accepted: false,
  marketing_consent: false,
  age_verified: false,
};

export default function ClientiPage() {
  const { search } = useLocation();
  const backTo = new URLSearchParams(search).get("from") === "app-management" ? "/gestione-app-clienti" : "/";
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(false);
  // permessi pacchetto
  const [hasFullPackage, setHasFullPackage] = useState(null); // null=non caricato


  // form inserimento
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState(initialNew);

  // filtri/ricerca/ordinamento
  const [q, setQ] = useState("");
  const [tipo, setTipo] = useState("ALL");
  const [store, setStore] = useState("");
  const [attivi, setAttivi] = useState("true"); // true | false | all
  const [ordina, setOrdina] = useState("name-asc");

  // modale modifica (semplice inline)
  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState({
    code: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    store: "",
    tipo_cliente: "STANDARD",
    is_active: true,
  });

    const fetchClienti = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access");
      const params = new URLSearchParams();
      if (q.trim()) params.set("q", q.trim());
      if (tipo !== "ALL") params.set("tipo", tipo);
      if (store.trim()) params.set("store", store.trim());
      if (attivi) params.set("attivi", attivi);

      const res = await fetch(`${API_URL}/api/clienti/?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      // 🔹 Normalizza tutte le forme possibili (array, results, clienti)
      const raw =
        Array.isArray(data) ? data :
        Array.isArray(data.results) ? data.results :
        Array.isArray(data.clienti) ? data.clienti :
        [];

      // 🔹 Crea sempre il campo "name" che il componente usa
      const arr = raw.map((c) => {
        const fullName = `${(c.first_name || "").trim()} ${(c.last_name || "").trim()}`.trim();
        return {
          ...c,
          name: c.name || c.nome || fullName || c.code,
        };
      });

      setClienti(arr);
    } catch (err) {
      console.error("❌ Errore nel caricamento clienti:", err);
      setClienti([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        const token = localStorage.getItem("access");

        const resMe = await fetch(`${API_URL}/api/me/`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const me = await resMe.json().catch(() => ({}));
        const full = !!me.has_full_package;
        setHasFullPackage(full);

        // ❌ FREE: non carichiamo i clienti, evitiamo 403 e UX inutile
        if (!full) return;

        // ✅ FULL: carichiamo la lista
        fetchClienti();
      } catch (e) {
        console.error("Errore init clienti:", e);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("access");
    const res = await fetch(`${API_URL}/api/clienti/aggiungi/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        code: "AUTO",
        tipo_cliente: "STANDARD",
        birth_date: formData.birth_date,
        is_adult_confirmed: formData.is_adult_confirmed,
        privacy_accepted: formData.privacy_accepted,
        terms_accepted: formData.terms_accepted,
        alcohol_policy_accepted: formData.alcohol_policy_accepted,
        marketing_consent: formData.marketing_consent,
        age_verified: formData.age_verified,
      }),
    });

    const data = await res.json();
    if (res.ok) {
      alert(data.detail || "Cliente inserito!");
      setFormData(initialNew);
      setShowForm(false);
      fetchClienti();
    } else {
      alert(data.detail || "Errore salvataggio");
    }
  };

  const eliminaCliente = async (code, name) => {
    if (!window.confirm(`Sei sicuro di voler rimuovere ${name} (${code})?`)) return;
    try {
      const token = localStorage.getItem("access");
      const res = await fetch(`${API_URL}/api/clienti/${code}/elimina/`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || "Errore eliminazione");

      setClienti((prev) => prev.filter((c) => c.code !== code));
    } catch (e) {
      alert(e.message || "Errore durante l'eliminazione");
    }
  };

  const apriModifica = async (code) => {
    try {
      const token = localStorage.getItem("access");
      const res = await fetch(`${API_URL}/api/clienti/${code}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.detail || "Errore caricamento");
      setEditData({
        code: d.code,
        first_name: d.first_name,
        last_name: d.last_name,
        email: d.email,
        phone: d.phone,
        store: d.store,
        tipo_cliente: d.tipo_cliente,
        is_active: !!d.is_active,
      });
      setEditOpen(true);
    } catch (e) {
      alert(e.message || "Errore apertura modifica");
    }
  };

  const salvaModifica = async () => {
    try {
      const token = localStorage.getItem("access");
      const res = await fetch(`${API_URL}/api/clienti/${editData.code}/`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          first_name: editData.first_name,
          last_name: editData.last_name,
          email: editData.email,
          phone: editData.phone,
          store: editData.store,
          tipo_cliente: editData.tipo_cliente,
          is_active: editData.is_active,
        }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.detail || "Errore salvataggio");

      setEditOpen(false);
      fetchClienti();
    } catch (e) {
      alert(e.message || "Errore salvataggio");
    }
  };

  const renderDebitoIcon = (livello) => {
    if (livello === "CRITICO") return <span className="me-2">🔴</span>;
    if (livello === "WARN") return <span className="me-2">🟡</span>;
    if (livello === "OK") return <span className="me-2">🟢</span>;
    return null;
  };

  // filtro + ordinamento in memoria (veloci)
  const clientiView = useMemo(() => {
    let arr = [...clienti];

    // ordinamento
    if (ordina === "name-asc") arr.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    if (ordina === "name-desc") arr.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    if (ordina === "code-asc") arr.sort((a, b) => String(a.code).localeCompare(String(b.code)));
    if (ordina === "code-desc") arr.sort((a, b) => String(b.code).localeCompare(String(a.code)));

    return arr;
  }, [clienti, ordina]);

  return (
    <div className="container mt-4">
      <TornaAlMenu to={backTo} />

      {/* Header */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h2 className="m-0">👥 Clienti</h2>
          <div className="d-flex gap-2">
            <button className="btn btn-success" onClick={() => setShowForm(true)}>
              + Nuovo Cliente
            </button>
            <button className="btn btn-outline-primary" onClick={fetchClienti}>
              🔄 Aggiorna
            </button>
          </div>
      </div>

      {/* Barra filtri/strumenti */}
      {!showForm && (
        <div className="card shadow-sm mb-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-12 col-md-4">
                <label className="form-label mb-1">Cerca</label>
                <input
                  className="form-control"
                  placeholder="🔎 Nome o codice…"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <label className="form-label mb-1">Tipo</label>
                <select className="form-select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                  <option value="ALL">Tutti</option>
                  <option value="STANDARD">STANDARD</option>
                  <option value="AZIENDA">AZIENDA</option>
                </select>
              </div>
              <div className="col-6 col-md-2">
                <label className="form-label mb-1">Store</label>
                <input
                  className="form-control"
                  placeholder="Es. ZioRoby"
                  value={store}
                  onChange={(e) => setStore(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <label className="form-label mb-1">Stato</label>
                <select className="form-select" value={attivi} onChange={(e) => setAttivi(e.target.value)}>
                  <option value="true">Solo attivi</option>
                  <option value="false">Solo disattivi</option>
                  <option value="all">Tutti</option>
                </select>
              </div>
              <div className="col-6 col-md-2">
                <label className="form-label mb-1">Ordina</label>
                <select className="form-select" value={ordina} onChange={(e) => setOrdina(e.target.value)}>
                  <option value="name-asc">Nome (A → Z)</option>
                  <option value="name-desc">Nome (Z → A)</option>
                  <option value="code-asc">Codice (A → Z)</option>
                  <option value="code-desc">Codice (Z → A)</option>
                </select>
              </div>
            </div>
            <div className="mt-2">
              <button className="btn btn-primary btn-sm me-2" onClick={fetchClienti}>
                Applica filtri
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => {
                  setQ(""); setTipo("ALL"); setStore(""); setAttivi("true"); setOrdina("name-asc"); fetchClienti();
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FORM elegante */}
      {showForm && (
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-white">
            <h5 className="m-0">📝 Nuovo Cliente</h5>
            <small className="text-muted">Inserisci i dati del cliente.</small>
          </div>
          <form className="card-body" onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Nome *</label>
                <input
                  className="form-control"
                  value={formData.first_name}
                  onChange={(e) => setFormData((f) => ({ ...f, first_name: e.target.value }))}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Cognome *</label>
                <input
                  className="form-control"
                  value={formData.last_name}
                  onChange={(e) => setFormData((f) => ({ ...f, last_name: e.target.value }))}
                  required
                />
              </div>
              <div className="col-md-4">
                  <label className="form-label">Store</label>
                  <div className="form-control bg-light text-muted">
                    Assegnato automaticamente allo store collegato
                  </div>
                </div>

              <div className="col-md-4">
                <label className="form-label">Telefono</label>
                <input
                  className="form-control"
                  value={formData.phone}
                  onChange={(e) => setFormData((f) => ({ ...f, phone: e.target.value }))}
                />
              </div>
              <div className="col-md-8">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => setFormData((f) => ({ ...f, email: e.target.value }))}
                />
              </div>
            </div>

            <div className="card bg-light border-0 mt-4">
              <div className="card-body">
                <h6 className="mb-3">Consensi e verifica cliente</h6>

                <div className="row g-3 mb-3">
                  <div className="col-md-4">
                    <label className="form-label">Data di nascita</label>
                    <input
                      type="date"
                      className="form-control"
                      value={formData.birth_date}
                      onChange={(e) => setFormData((f) => ({ ...f, birth_date: e.target.value }))}
                    />
                  </div>
                </div>

                {[
                  ["is_adult_confirmed", "Maggiorenne confermato"],
                  ["privacy_accepted", "Privacy accettata"],
                  ["terms_accepted", "Termini accettati"],
                  ["alcohol_policy_accepted", "Condizioni vendita alcolici accettate"],
                  ["marketing_consent", "Consenso marketing"],
                  ["age_verified", "Età / documento verificato dal negozio"],
                ].map(([field, label]) => (
                  <div className="form-check mb-2" key={field}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`new-${field}`}
                      checked={!!formData[field]}
                      onChange={(e) => setFormData((f) => ({ ...f, [field]: e.target.checked }))}
                    />
                    <label className="form-check-label" htmlFor={`new-${field}`}>
                      {label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button type="button" className="btn btn-outline-secondary" onClick={() => setShowForm(false)}>
                Annulla
              </button>
              <button className="btn btn-primary" type="submit">
                Salva Cliente
              </button>
            </div>
          </form>
        </div>
      )}

      {/* LISTA */}
      {loading ? (
        <p className="text-muted">Caricamento…</p>
      ) : clientiView.length > 0 ? (
        <div className="row g-3">
          {clientiView.map((c) => (
            <div className="col-12 col-md-6 col-lg-4" key={c.code}>
              <div
                  className={`card h-100 shadow-sm ${
                    c.livello_debito === "CRITICO"
                      ? "border-danger border-3"
                      : c.livello_debito === "WARN"
                      ? "border-warning border-3"
                      : "border-secondary border-2"
                  }`}
                  style={{ transition: "transform .08s ease-in-out" }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                >

                <div className="card-body d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-1">
                    <div className="d-flex align-items-center">
                      {renderDebitoIcon(c.livello_debito)}
                      <Link to={`/clienti/${c.code}`} className="card-title h5 text-decoration-none mb-0">
                        {c.name}
                      </Link>
                    </div>
                    <span className="badge bg-light text-dark">Cod. {c.code}</span>
                  </div>

                  <div className="mb-2">
                    <span className={`badge ${c.is_active ? "bg-success" : "bg-secondary"} me-2`}>
                      {c.is_active ? "Attivo" : "Disattivato"}
                    </span>
                    <span className="badge bg-dark-subtle text-dark">{c.tipo_cliente}</span>
                  </div>

                  {c.email && <div className="small text-muted">📧 {c.email}</div>}
                  {c.phone && <div className="small text-muted">📞 {c.phone}</div>}
                  {c.store && <div className="small text-muted">🏬 {c.store}</div>}

                  <div className="mt-auto d-flex justify-content-between pt-3">
                    <button className="btn btn-sm btn-outline-primary" onClick={() => apriModifica(c.code)}>
                      Modifica
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => eliminaCliente(c.code, c.name)}
                    >
                      Elimina
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        !showForm && <p className="text-muted">Nessun cliente trovato.</p>
      )}

      {/* Modale modifica */}
      {editOpen && (
        <div className="modal d-block" onClick={() => setEditOpen(false)}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>✏️ Modifica Cliente – {editData.code}</h5>
                <button className="btn-close" onClick={() => setEditOpen(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="form-label">Nome</label>
                    <input
                      className="form-control"
                      value={editData.first_name}
                      onChange={(e) => setEditData({ ...editData, first_name: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Cognome</label>
                    <input
                      className="form-control"
                      value={editData.last_name}
                      onChange={(e) => setEditData({ ...editData, last_name: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Telefono</label>
                    <input
                      className="form-control"
                      value={editData.phone}
                      onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      className="form-control"
                      value={editData.email}
                      onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Store</label>
                    <input
                      className="form-control"
                      value={editData.store}
                      onChange={(e) => setEditData({ ...editData, store: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tipo Cliente</label>
                    <select
                      className="form-select"
                      value={editData.tipo_cliente}
                      onChange={(e) => setEditData({ ...editData, tipo_cliente: e.target.value })}
                    >
                      <option value="STANDARD">STANDARD</option>
                      <option value="AZIENDA">AZIENDA</option>
                    </select>
                  </div>
                  <div className="col-12 mt-2">
                    <div className="form-check">
                      <input
                        id="activeCheck"
                        className="form-check-input"
                        type="checkbox"
                        checked={editData.is_active}
                        onChange={(e) => setEditData({ ...editData, is_active: e.target.checked })}
                      />
                      <label className="form-check-label" htmlFor="activeCheck">
                        Cliente attivo
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditOpen(false)}>
                  Annulla
                </button>
                <button className="btn btn-primary" onClick={salvaModifica}>
                  Salva modifiche
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
